export class SerializableClass {
	private readonly serializable = true;
}
